import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaPaypal, FaBitcoin, FaUniversity, FaCreditCard } from "react-icons/fa";

const MetodoPagoPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const opciones = [
    {
      id: "paypal",
      icono: <FaPaypal size={32} className="text-blue-500" />,
      disponible: true,
    },
    {
      id: "iban",
      icono: <FaUniversity size={32} className="text-green-600" />,
      disponible: false,
    },
    {
      id: "stripe",
      icono: <FaCreditCard size={32} className="text-indigo-500" />,
      disponible: false,
    },
    {
      id: "blockchain",
      icono: <FaBitcoin size={32} className="text-yellow-500" />,
      disponible: false, // Desactivado
    },
  ];

  const tooltipMsg = t("payment.not_available_tooltip");

  return (
    <div className="max-w-5xl mx-auto p-6 mt-5">
      <h2 className="text-3xl font-bold text-center mb-6">
        {t("payment.fields.select_method")}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {opciones.map((opcion) => (
          <div
            key={opcion.id}
            onClick={() =>
              opcion.disponible ? navigate(`/perfil/metodo-pago/${opcion.id}`) : null
            }
            className={`relative group transition border rounded-xl p-5 flex items-center space-x-4 shadow-md ${
              opcion.disponible
                ? "bg-white hover:bg-gray-50 cursor-pointer border-gray-200 hover:border-blue-400"
                : "bg-gray-100 border-gray-300 opacity-60 cursor-not-allowed"
            }`}
          >
            <div>{opcion.icono}</div>
            <div>
              <h3 className="text-xl font-semibold">
                {t(`payment.fields.methods.${opcion.id}.title`)}
              </h3>
              <p className="text-sm text-gray-600">
                {t(`payment.fields.methods.${opcion.id}.description`)}
              </p>
            </div>

            {!opcion.disponible && (
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max bg-black text-white text-xs px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                {tooltipMsg}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetodoPagoPage;
